export default __webpack_public_path__ + "static/media/1919.37e27d38.png";